import { makeStyles, Text, tokens } from '@fluentui/react-components';
import type { ReactNode } from 'react';

import { spacing } from '@/theme/tokens';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.xxs,
  },
  rootInline: {
    flexDirection: 'row',
    alignItems: 'baseline',
    gap: spacing.s,
  },
  label: {
    color: tokens.colorNeutralForeground3,
    textTransform: 'uppercase',
    letterSpacing: '0.04em',
  },
  value: {
    color: tokens.colorNeutralForeground1,
    fontFeatureSettings: '"tnum" 1',
  },
});

interface KeyValueProps {
  label: string;
  children: ReactNode;
  inline?: boolean;
}

export function KeyValue({ label, children, inline }: KeyValueProps) {
  const classes = useStyles();
  return (
    <div className={inline ? `${classes.root} ${classes.rootInline}` : classes.root}>
      <Text size={100} weight="semibold" className={classes.label}>
        {label}
      </Text>
      <Text size={300} className={classes.value}>
        {children}
      </Text>
    </div>
  );
}
